import api, { normalizeEndpoint } from './httpClient';

// Generic CRUD operations
export const apiService = {
  // Get all items of a specific type
  getAll: async (endpoint) => {
    try {
      const response = await api.get(normalizeEndpoint(endpoint));
      return response.data.data || response.data;
    } catch (error) {
      throw error;
    }
  },
  
  // Get a single item by ID
  getById: async (endpoint, id) => {
    try {
      const response = await api.get(`${normalizeEndpoint(endpoint)}/${id}`);
      return response.data.data || response.data;
    } catch (error) {
      throw error;
    }
  },
  
  // Create a new item
  create: async (endpoint, data) => {
    try {
      const response = await api.post(normalizeEndpoint(endpoint), data);
      return response.data.data || response.data;
    } catch (error) {
      throw error;
    }
  },
  
  // Update an existing item
  update: async (endpoint, id, data) => {
    try {
      const response = await api.put(`${normalizeEndpoint(endpoint)}/${id}`, data);
      return response.data.data || response.data;
    } catch (error) {
      throw error;
    }
  },
  
  // Delete an item
  delete: async (endpoint, id) => {
    try {
      const response = await api.delete(`${normalizeEndpoint(endpoint)}/${id}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  
  // Direct post method for auth and other non-CRUD operations
  post: async (endpoint, data) => {
    try {
      const response = await api.post(normalizeEndpoint(endpoint), data);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  
  // Direct get method for non-standard endpoints
  get: async (endpoint) => {
    try {
      const response = await api.get(normalizeEndpoint(endpoint));
      return response.data.data || response.data;
    } catch (error) {
      throw error;
    }
  },

  put: async (endpoint, data) => {
    try {
      const response = await api.put(normalizeEndpoint(endpoint), data);
      return response.data.data || response.data;
    } catch (error) {
      throw error;
    }
  },

  raw: api,
  getBaseUrl: () => api.defaults.baseURL,
};
